var amdi18n={"__root":{"cancel":"Cancel","clear":"Clear"},"__cs":{"cancel":"Storno","clear":"Vymazat"},"__da":{"cancel":"Annullér","clear":"Ryd"},"__de":{"cancel":"Abbrechen","clear":"Aufheben"},"__es":{"cancel":"Cancelar","clear":"Borrar"},"__fi":{"cancel":"Peruuta","clear":"Tyhjennä"},"__fr":{"cancel":"Annuler","clear":"Effacer"},"__hr":{"cancel":"Opoziv","clear":"Isprazni"},"__hu":{"cancel":"Mégse","clear":"Törlés"},"__it":{"cancel":"Annulla","clear":"Annulla"},"__ja":{"cancel":"キャンセル","clear":"クリア"},"__kk":{"cancel":"Болдырмау","clear":"Тазалау"},"__ko":{"cancel":"취소","clear":"지우기"},"__nb":{"cancel":"Avbryt","clear":"Fjern"},"__nl":{"cancel":"Annuleren","clear":"Verwijderen"},"__no":{"cancel":"Avbryt","clear":"Fjern"},"__pl":{"cancel":"Anuluj","clear":"Wyczyść"},"__pt":{"cancel":"Cancelar","clear":"Limpar"},"__pt-br":{"cancel":"Cancelar","clear":"Limpar"},"__ro":{"cancel":"Anulare","clear":"Curăţare"},"__ru":{"cancel":"Отмена","clear":"Очистить"},"__sl":{"cancel":"Prekliči","clear":"Počisti"},"__sv":{"cancel":"Avbryt","clear":"Radera"},"__th":{"cancel":"ยกเลิก","clear":"เคลียร์"},"__tr":{"cancel":"İptal","clear":"Temizle"},"__zh":{"cancel":"取消","clear":"清除"},"__zh-cn":{"cancel":"取消","clear":"清除"},"__zh-hk":{"cancel":"取消","clear":"清除"},"__zh-mo":{"cancel":"取消","clear":"清除"},"__zh-sg":{"cancel":"取消","clear":"清除"},"__zh-tw":{"cancel":"取消","clear":"清除"}};amdi18n.init=function (language){
		// get the default language
		if(!language){
			if(window._i18n && window._i18n.locale){
				language = window._i18n.locale;
			}else if(document.documentElement.lang){
				language = document.documentElement.lang;
			}else{
				language = 'root';
			}
		}
		var target = this['__' + language] || this.__root;

		// copy definition to root level
		if (target) {
			for (var name in target) {
				this[name] = target[name];
			}
		}

		// fallback to root
		for(var name in this.__root){
			if(typeof this[name] === 'undefined'){
				this[name] = this.__root[name];
			}
		}
	};amdi18n.init();module.exports=amdi18n;